<template>
  <div :class="$style.container">
    <Grid
      :class="$style.customGrid"
      :hasGap="false"
    >
      <GridItem :gridSpan="6">
        <PhoneNumberInput
          v-model="user.phone"
          :data-test-id="$testId('PhoneNumberInput')"
          enabledFlags
          :label="inputFields.phone.label"
          :required="user.hasPhonePreference"
          @blur="sendInputEnteredEvent(inputFields.phone)"
        />
      </GridItem>
      <GridItem
        :class="$style.customGridItem"
        :gridSpan="6"
      >
        <Checkbox
          v-model="user.hasPhonePreference"
          :class="$style.checkbox"
          :data-test-id="$testId('Checkbox')"
          :label="inputFields.hasPhonePreference.label"
          @blur="sendInputEnteredEvent(inputFields.hasPhonePreference)"
        />
      </GridItem>
    </Grid>
  </div>
</template>

<script>
import {
  Checkbox,
  Grid,
  GridItem,
  PhoneNumberInput,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'PhoneNumber',

  components: {
    Checkbox,
    Grid,
    GridItem,
    PhoneNumberInput,
  },

  data() {
    return {
      inputFields: {
        phone: {
          label: 'Phone',
          name: 'phone',
        },
        hasPhonePreference: {
          label: 'I prefer to be contacted by phone',
          name: 'hasPhonePreference',
        },
      },
    };
  },

  computed: {
    ...mapState([
      'user',
    ]),
  },

  methods: {
    ...mapActions([
      'sendInputEnteredEvent',
    ]),
  },
};
</script>

<style scoped module>
.container {
  border-bottom: var(--jc-border-width) solid var(--jc-border-color-medium);
  margin-bottom: var(--jc-spacer);
  padding-bottom: var(--jc-spacer);
}

.checkbox {
  padding-top: var(--jc-spacer-x-small);
}

.customGrid {
  column-gap: var(--jc-size-2p25);
  row-gap: var(--jc-spacer);
}

.customGridItem {
  display: flex;
  align-items: center;
}
</style>
